import { render, staticRenderFns } from "./AppPagePlayContainer.vue?vue&type=template&id=57d3b7e8&scoped=true&"
import script from "./AppPagePlayContainer.vue?vue&type=script&lang=js&"
export * from "./AppPagePlayContainer.vue?vue&type=script&lang=js&"
import style0 from "./AppPagePlayContainer.vue?vue&type=style&index=0&id=57d3b7e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d3b7e8",
  null
  
)

export default component.exports